export const textToImage = "Text‑to‑Image";
export const textToText = "Text‑to‑Text";
export const imageToImage = "Image‑to‑Image";
export const imageToText = "Image‑to‑Text";
export const allToImage = `${textToImage}, ${imageToImage}`;

export const allDescriptions = [
  textToText,
  textToImage,
  imageToImage,
  allToImage,
  imageToText,
];

export const netsAnalysisType = {
  cubalibre: imageToImage,
  strawberrypunch: allToImage,
  berrypunch: allToImage,
  darjeeling: textToText,
  volcanicwater: allToImage,
  kiba: imageToImage,
  barraquito: imageToText,
};
